import TeamDisplay from './TeamDisplay';

interface TeamsOverviewProps {
  homeTeam: {
    isTeamAvailable: boolean;
    isNationalTeam: boolean;
    internationalName: string;
    countryCode?: string;
    displayName?: string;
    logoUrl?: string;
  };
  awayTeam: {
    isTeamAvailable: boolean;
    isNationalTeam: boolean;
    internationalName: string;
    countryCode?: string;
    displayName?: string;
    logoUrl?: string;
  };
  isDesktop: boolean;
  badgeSize: number;
  clubName: string;
}

const TeamsOverview = ({ homeTeam, awayTeam, isDesktop, badgeSize, clubName }: TeamsOverviewProps) => {
  return (
    <div className="pk-d--flex pk-justify-content--between pk-mt--m pk-mt-md--xl pr-pl--19p">
      <TeamDisplay
        isTeamAvailable={homeTeam.isTeamAvailable}
        isNationalTeam={homeTeam.isNationalTeam}
        internationalName={homeTeam.internationalName}
        displayName={homeTeam.displayName}
        countryCode={homeTeam.countryCode}
        logoUrl={homeTeam.logoUrl}
        slot="prefix"
        isDesktop={isDesktop}
        badgeSize={badgeSize}
        clubName={clubName}
      />
      <div className="pr-pr--23p">
        <TeamDisplay
          isTeamAvailable={awayTeam.isTeamAvailable}
          isNationalTeam={awayTeam.isNationalTeam}
          internationalName={awayTeam.internationalName}
          displayName={awayTeam.displayName}
          countryCode={awayTeam.countryCode}
          logoUrl={awayTeam.logoUrl}
          slot="suffix"
          isDesktop={isDesktop}
          badgeSize={badgeSize}
          clubName={clubName}
        />
      </div>
    </div>
  );
};

export default TeamsOverview;
